module.exports = __webpack_public_path__ + "static/img/zy.8e0f014.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/zy.png
// module id = IpDW
// module chunks = 1